import Icon from '../../lib/Icon';
import { badge, zeb } from '../../lib/format';
import { cardPad } from '../../lib/ui';
import { useApp } from '../../state/AppContext';

export default function Rpt() {
  const { L } = useApp();
  const rptKpis = [
    { label: L('Open RPTs', 'RPT ที่เปิดอยู่'), value: '2', color: 'var(--color-warning)' },
    { label: L('Disclosed', 'เปิดเผยแล้ว'), value: '4', color: 'var(--color-success)' },
    { label: L('Not Disclosed', 'ไม่เปิดเผย'), value: '1', color: 'var(--color-error)' },
    { label: L('RPT Value (FY)', 'มูลค่า RPT (ปีบัญชี)'), value: '$9.20M', color: 'var(--color-fg-1)' },
  ];
  const rptRows = [
    { id: 'RPT-2026-002', sup: 'Apex Insurance Co.', party: 'Coleman Holdings', rel: L('Common director', 'กรรมการร่วม'), po: 'PO-2026-0041', value: '$4.62M', disc: 'Disclosed', by: 'Wendy N.' },
    { id: 'RPT-2026-005', sup: 'Summit Underwriters', party: 'Coleman Holdings', rel: L('Common director', 'กรรมการร่วม'), po: 'RFQ-2026-004', value: '$7.20M', disc: 'Not Disclosed', by: '—' },
    { id: 'RPT-2025-018', sup: 'GeoTrack Solutions', party: 'ACME Logistics', rel: L('Group affiliate', 'บริษัทในเครือ'), po: 'PO-2025-0112', value: '$1.90M', disc: 'Disclosed', by: 'Maria B.' },
  ].map((r, i) => {
    const b = badge(r.disc);
    return { ...r, zebra: zeb(i), dBg: b.bg, dFg: b.fg };
  });
  const rptDirectors = [
    { name: 'Daniel Coleman', appears: 'Apex, Summit', risk: 'High' },
    { name: 'Victor Lim', appears: 'Apex', risk: 'Medium' },
    { name: 'Marcus Reed', appears: 'Meridian', risk: 'Low' },
  ].map((d) => {
    const b = badge(d.risk);
    return { ...d, rBg: b.bg, rFg: b.fg };
  });

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', background: 'var(--color-error-bg)', border: '1px solid var(--color-error)', borderRadius: 'var(--radius-md)', marginBottom: 16, color: 'var(--color-error)' }}>
        <Icon name="alert-triangle" />
        <span style={{ color: 'var(--color-fg-1)', fontSize: 13 }}>{L('1 transaction not disclosed — report to the Audit Committee within 3 business days.', '1 รายการยังไม่เปิดเผย — รายงานต่อคณะกรรมการตรวจสอบภายใน 3 วันทำการ')}</span>
        <div style={{ flex: 1 }} />
        <button className="hv-white" style={{ padding: '8px 14px', border: '1px solid var(--color-error)', borderRadius: 'var(--radius-sm)', fontSize: 13, fontWeight: 600, color: 'var(--color-error)', background: 'transparent' }}>{L('Export to PDF', 'ส่งออกเป็น PDF')}</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 16 }}>
        {rptKpis.map((k) => (
          <div key={k.label} style={cardPad('16px 18px')}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)', marginBottom: 6 }}>{k.label}</div>
            <div style={{ fontSize: 22, fontWeight: 700, fontFamily: 'var(--font-mono)', color: k.color }}>{k.value}</div>
          </div>
        ))}
      </div>

      <div style={{ ...cardPad(0, 'auto'), marginBottom: 16 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 1000 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('RPT ID', 'รหัส RPT')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Supplier', 'ซัพพลายเออร์')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Related Party', 'บุคคลที่เกี่ยวโยงกัน')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Relationship', 'ความสัมพันธ์')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>PO</th>
              <th style={{ textAlign: 'right', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Value', 'มูลค่า')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Disclosure', 'การเปิดเผย')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Detected By', 'ตรวจพบโดย')}</th>
            </tr>
          </thead>
          <tbody>
            {rptRows.map((r) => (
              <tr key={r.id} style={{ borderBottom: '1px solid var(--color-border)', background: r.zebra }}>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{r.id}</td>
                <td style={{ padding: '12px 16px', fontWeight: 600 }}>{r.sup}</td>
                <td style={{ padding: '12px 16px' }}>{r.party}</td>
                <td style={{ padding: '12px 16px', color: 'var(--color-fg-2)' }}>{r.rel}</td>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{r.po}</td>
                <td style={{ padding: '12px 16px', textAlign: 'right', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{r.value}</td>
                <td style={{ padding: '12px 16px' }}><span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: r.dBg, color: r.dFg }}>{r.disc}</span></td>
                <td style={{ padding: '12px 16px', color: 'var(--color-fg-2)' }}>{r.by}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={cardPad(20)}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>{L('Shared Director Network Summary', 'สรุปเครือข่ายกรรมการร่วม')}</div>
        <div style={{ fontSize: 12, color: 'var(--color-fg-3)', marginBottom: 14 }}>{L('Cross-referenced against the government business registry.', 'ตรวจสอบข้ามกับทะเบียนธุรกิจของรัฐบาล')}</div>
        {rptDirectors.map((d) => (
          <div key={d.name} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderBottom: '1px solid var(--color-border)' }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{d.name}</div>
              <div style={{ fontSize: 11, color: 'var(--color-fg-3)' }}>{L('Appears in:', 'ปรากฏใน:')} {d.appears}</div>
            </div>
            <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: d.rBg, color: d.rFg }}>{d.risk}</span>
          </div>
        ))}
      </div>
    </>
  );
}
